import { createSlice } from "@reduxjs/toolkit";
import { getSalesContractDetail } from "./thunk";

export const initialState = {
  // getPagedContracts
  getSalesContractDetailData: {},
  getSalesContractDetailError: {},
  isSalesContractDetailListSuccess: false,
  // Error Handling
  error: false,
};

const ContractsSlice = createSlice({
  name: "ContractsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getSalesContractDetail
    builder.addCase(
      getSalesContractDetail.fulfilled,
      (state: any, action: any) => {
        state.getSalesContractDetailData = action.payload;
        state.isSalesContractDetailListSuccess = true;
      }
    );
    builder.addCase(
      getSalesContractDetail.rejected,
      (state: any, action: any) => {
        state.getSalesContractDetailError = action.payload || null;
        state.error = action.payload || null;
      }
    );
  },
});

export default ContractsSlice.reducer;
